import { Component, OnInit, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  
  check:boolean=false;
  onClick(){
    this.check = !this.check;
  }
  
  onReturnHome(){
    this.router.navigate(['home']);
  }
  onHome(){
    this.router.navigate(['home']);
    this.onClick();
  }
  onAbout(){
    this.router.navigate(['about']);
    this.onClick();
  }
  onExpertise(){
    this.router.navigate(['expertise']);
    this.onClick();
  }
  onProducts(){
    this.router.navigate(['products']);
    this.onClick();
  }
  onContact(){
    this.router.navigate(['contact']);
    this.onClick();
  }
  
  scroll_down:boolean=false;
  nav_down:boolean=false;
  @HostListener("document:scroll")
  scrollFunction(){
    if(document.body.scrollTop>1000 || document.documentElement.scrollTop>1000){
      this.scroll_down=true;
    }
    else{
      this.scroll_down=false;
    }
    if(document.body.scrollTop>408 || document.documentElement.scrollTop>408){
      this.nav_down=true;
    }
    else{
      this.nav_down=false;
    }
  }
  
  scrollToTop(){
    window.scrollTo({top: 0,behavior: "smooth"});
  }

}
